<template>
  <!-- 配额订单下单 -->
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">配额订单下单</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="pageMode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY001', 'WLY002', 'WLYALL']) && !conditions.OBJECT_ID">
          <form-button
            type="primary"

            @click="changeStatus('SAVE')"
          >保存</form-button>
        </template>
        <template v-if="conditions.OBJECT_ID">
          <template v-if="conditions.STATUS === 'E0004'">
            <template v-if="conditions.change">
              <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
            </template>
            <template v-if="conditions.follow_up && !showEdit">
              <form-button @click="showNext = true">创建后续</form-button>
            </template>
          </template>

          <template v-else-if="conditions.STATUS === 'E0003'">
            <form-button v-if="!showEdit && $_has(['WLY002', 'WLYALL'])" @click="orderModify">修改</form-button>
          </template>

          <template
            v-else-if="
              conditions.STATUS !== 'E0006' && $_has(['WLY001', 'WLY002', 'WLYALL']) && !showEdit
            "
          >
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template
            v-if="
              conditions.STATUS !== 'E0006' && $_has(['WLY002', 'WLY006', 'WLYALL']) && !showEdit
            "
          >
            <form-button @click="orderlock('UNLOCK')">订单解锁</form-button>
          </template>
        </template>

        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="orderDisplay">显示</form-button>
          <template v-if="conditions.STATUS === 'E0002' || conditions.STATUS === 'E0005'">

            <form-button
              v-if="$_has(['WLY001', 'WLY002', 'WLYALL'])"
              type="primary"

              @click="changeStatus('SAVE')"
            >保存</form-button>
            <form-button v-if="$_has(['WLY002', 'WLYALL'])" icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>

            <form-button v-if="$_has(['WLY001', 'WLY002', 'WLYALL'])" @click="changeStatus('CANCEL')">取消</form-button>

          </template>

          <template v-if="conditions.STATUS === 'E0003'">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <form-button @click="changeStatus('REJECT')">审核拒绝</form-button>
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>

          <template v-if="conditions.STATUS === 'E0004' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        :show-message="false"
        :disabled="isEdit"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input :value="conditions.OBJECT_ID" disabled />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select :value="conditions.PROCESS_TYPE" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input :value="conditions.CUST_NAME" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <wly-input
                v-model="conditions.CUSTOMER"
                :disabled="role.ROLE === 'WLY001'"
                input-type="customer"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog($event, 'client')"
              />
              <!-- <el-input
                v-model="conditions.CUSTOMER"
                :disabled="isEdit"
                placeholder="请输入"
                @focus="openSelectDialog($event, 'client')"
              /> -->
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.CUSTOMER_TYPE" placeholder="" clearable disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.ZCUSTOM_NAME" placeholder="" clearable :disabled="isEdit" />
            </el-form-item>
          </el-col>

          <!-- TODO 四个字段另外api取 -->
          <!-- <el-col :lg="8" :md="12">
            <el-form-item prop="ZHKYE" label="贷款余额">
              <el-input
                v-model.trim="conditions.ZHKYE"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="随量保证金">
              <el-input
                v-model="conditions.followMarginMoney"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票要求">
              <el-input
                v-model="conditions.billingRequire"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="固定保证金">
              <el-input
                v-model="conditions.fixedMarginMoney"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                type="textarea"
                :disabled="isEdit"
                rows="4"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                :disabled="conditions.STATUS !== 'E0003'"
                rows="4"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input :value="conditions.ZZFLD00002D_DSCR" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建时间">
              <el-input :value="conditions.POSTING_DATE" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select :value="conditions.STATUS" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="ZZFLD000001">
              <!-- :disabled="isEdit" -->
              <el-select
                v-model="conditions.ZZFLD000001"
                :disabled="!selectDataOptions.orgList || selectDataOptions.orgList.length == 1"
                placeholder=""
                @change="saleCenterChange"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input :value="conditions.ZZFLD00003E" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input :value="conditions.ZZFLD000002_TEXT" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input :value="conditions.ZZFLD000003_TEXT" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input :value="conditions.ZZFLD000004_DSCR" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="订单行项目(计划内)" :custome-config="() => vxeShowCustom('xTable0')">
        <template #button v-if="conditions.STATUS === 'E0001' || conditions.STATUS === 'E0002'">
          <table-button
            name="save"
            :disabled="isEdit"
            tip="保存"
            @click="saveSaleItem('ITEM_INNER')"
          />
          <table-button name="add" :disabled="isEdit" tip="增加" @click="tableEvent('innerAdd')" />
          <table-button
            name="delete"
            :disabled="isEdit"
            tip="删除"
            @click="deleteSaleItem('ITEM_INNER')"
          />
        </template>
        <vxe-grid
          ref="xTable0"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #ZZFLD000006="{row}">
            <el-date-picker
              v-model="row.ZZFLD000006"
              type="date"
              value-format="yyyyMMdd"
              :disabled="isEdit || role.ROLE === 'WLY001'"
              size="mini"
              :clearable="false"
            />
          </template>
          <template #ZZFLD000005="{row}">
            <el-input
              v-model="row.ZZFLD000005"
              :disabled="isEdit"
              size="mini"
              @focus="openSelectDialog($event, 'salePlan', row, 'ITEM_INNER')"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              size="mini"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : (isEdit || (conditions.STATUS !== 'E0001' && conditions.STATUS !== 'E0002'))"
              placeholder=""
            >
              <el-option
                v-for="item in selectDataOptions['A0037']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #ORDERED_PROD="{row}">
            <wly-input
              v-model="row.ORDERED_PROD"
              size="mini"
              :disabled="isEdit"
              input-type="salesProduct"
              :sales-query-params="productParams"
              @enter="handleEnter(...arguments, row, 'ITEM_INNER')"
              @handleSuffixClick="openSelectDialog($event, 'product', row, 'ITEM_INNER')"
            />
          </template>
          <template #ZZFLD000009="{row}">
            <el-input
              v-model.number="row.ZZFLD000009"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="saveSaleItem('ITEM_INNER')"
            />
          </template>
          <template #USE_BOT="{row}">
            <el-input
              v-model.number="row.USE_BOT"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="saveSaleItem('ITEM_INNER')"
            />
          </template>
          <template #REWARD_TYPE="{row,rowIndex}">
            <el-select
              :disabled="isEdit "
              v-model="row.REWARD_TYPE"
              size="mini"
              placeholder=""
              clearable
              @change='changeType($event,rowIndex)'
            >
              <el-option
                v-for="item2 in selectDataOptions['A0076']"
                :key="item2.value"
                :label="item2.name"
                :value="item2.value"
              />
            </el-select>
          </template>
          <template #REWARD_NUMBER="{row}">
            <el-input
              v-model="row.REWARD_NUMBER"
              :disabled="isEdit || !row.REWARD_TYPE"
              size="mini"
              @focus="openSelectDialog($event, 'reward', row, 'ITEM_INNER')"
            />
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input
              v-model="row.ZZFLD00002I"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              type="number"
              @keyup.enter.native="saveSaleItem('ITEM_INNER')"
            />
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox v-model="row.ZZFLD00002B" true-label="X" false-label="" disabled>是</el-checkbox>
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="saveSaleItem('ITEM_INNER')"
            />
          </template>
          <template #NUMBER_INT="{row}">
            <span>
              {{ Number(row.NUMBER_INT) }}
            </span>
          </template>
          <template #ZZFLD00002P="{row}">
            <span>
              {{ Number(row.ZZFLD00002P) }}
            </span>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="剩余现金奖励" :custome-config="() => vxeShowCustom('fileTable')" v-if="role.ROLE == 'WLY002' || role.ROLE == 'WLYALL'">
        <template #button>
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsCash.columns"
          :data="gridOptionsCash.data"
        >
          <!-- <template #toolbar /> -->
          <!-- <template #FILENAME="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template> -->
        </vxe-grid>
      </TableCommon>

      <TableCommon title="剩余促销奖励" :custome-config="() => vxeShowCustom('fileTable')" v-if="(role.ROLE == 'WLY002' || role.ROLE == 'WLYALL') && gridOptionsPromotion.data.length">
        <template #button>
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsPromotion.columns"
          :data="gridOptionsPromotion.data"
        >
        </vxe-grid>
      </TableCommon>

      <TableCommon title="订单行项目(计划外)" :custome-config="() => vxeShowCustom('xTable1')">
        <template #button v-if="conditions.STATUS === 'E0001' || conditions.STATUS === 'E0002'">
          <table-button
            name="save"
            :disabled="isEdit"
            tip="保存"
            @click="saveSaleItem('ITEM_OUTER')"
          />
          <table-button
            name="delete"
            :disabled="isEdit"
            tip="删除"
            @click="deleteSaleItem('ITEM_OUTER')"
          />
        </template>
        <vxe-grid
          ref="xTable1"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsOuterPlan.columns"
          :data="gridOptionsOuterPlan.data"
        >
          <template #ZZFLD000009="{row}">
            <el-input
              v-model.number="row.ZZFLD000009"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="saveSaleItem('ITEM_OUTER')"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              placeholder=""
              clearable
            >
              <el-option
                v-for="item2 in selectDataOptions['A0037']"
                :key="item2.value"
                :label="item2.name"
                :value="item2.value"
              />
            </el-select>
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input
              v-model="row.ZZFLD00002I"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              type="number"
              @keyup.enter.native="saveSaleItem('ITEM_OUTER')"
            />
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="saveSaleItem('ITEM_OUTER')"
            />
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox v-model="row.ZZFLD00002B" true-label="X" false-label="" disabled>是</el-checkbox>
          </template>
          <template #NUMBER_INT="{row}">
            <span>
              {{ Number(row.NUMBER_INT) }}
            </span>
          </template>
          <template #ZZFLD00002P="{row}">
            <span>
              {{ Number(row.ZZFLD00002P) }}
            </span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="占用销售计划明细" :custome-config="() => vxeShowCustom('xTable2')">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsPlanDetail.columns"
          :data="gridOptionsPlanDetail.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptionsPlanDetail.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="关联销售计划明细" :custome-config="() => vxeShowCustom('xTable2')">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsRelevanceDetail.columns"
          :data="gridOptionsRelevanceDetail.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptionsRelevanceDetail.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <!-- <template #toolbar /> -->
          <template #FILENAME="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="操作变更记录">
        <vxe-grid
          ref="xTable5"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>

      <TableCommon title="关联单据">
        <vxe-grid
          ref="gridOptionsLinkBill"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsLinkBill.columns"
          :data="gridOptionsLinkBill.data"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <cashRewards v-if="showDialogType === 'reward' && innerCurrentDetail.REWARD_TYPE === 'V001'" :head='conditions' :allData="gridOptions.data" :item="innerCurrentDetail" ref="dialogEdit"/>
        <promotionRewards v-if="showDialogType === 'reward' && innerCurrentDetail.REWARD_TYPE === 'V002'" :head='conditions' :allData="gridOptions.data" :item="innerCurrentDetail" ref="dialogEdit"/>
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <sale-plan-select
          v-if="showDialogType === 'salePlan'"
          ref="dialogEdit"
          :info="conditions"
          :item="innerCurrentDetail"
        />
        <sale-product-select
          v-if="showDialogType === 'product'"
          ref="dialogEdit"
          :info="productParams"
        />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="showNext" title="后续单据选择">
      <vxe-grid
        ref="next"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        align="center"
        size="mini"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptionsNext.columns"
        :data="gridOptionsNext.data"
      />
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showNext = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="createNext"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { apiSapSingleClientInfo, apiOrderLock } from '@/api/common'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { sapDownloadFile } from '@/utils/frontExport'
import {
  apiQuotaUpdateSaleItem,
  apiQuotaSave,
  getOrderDetail,
  apiCreateFollow
} from '@/api/sap/order-sap'
import { getSalePlanNumber } from '@/api/sap/client-sap'
const cashRewards = () => import('@/views/reward-policy/components/cashRewards.vue')
const promotionRewards = () => import('@/views/reward-policy/components/promotionRewards.vue')
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const SalePlanSelect = () => import('@/components/dialog/SalePlanSelect')
const SaleProductSelect = () => import('@/components/dialog/SaleProductSelect')
import { mapGetters } from 'vuex'
export default {
  components: {
    ClientSelect,
    SalePlanSelect,
    SaleProductSelect,
    cashRewards,
    promotionRewards
  },
  data() {
    const rules = {
      CUSTOMER: [{ required: true, message: '请选择客户', trigger: 'change' }],
      ZZFLD000001: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
    }
    return {
      rules,
      pageMode: 'add',
      showEdit: false,
      showNext: false,
      validRules: {
        ZZFLD000006: [{ required: true, message: '2' }],
        ZZFLD000005: [{ required: true }],
        // ZZFLD000009: [{ required: true }],
        ORDERED_PROD: [{ required: true }]
      },
      errorList: [],
      item_type: '',
      showDialogType: '',
      showDialog: false,
      dialogTitle: '',
      selectDataOptions: {
        orgList: []
      },
      productParams: {
        process_type: 'ZS01',
        mode: 'QUOTA',
        CUSTOMER: ''
        // isMdmClient: 1
      },
      innerCurrentDetail: {
        product: {},
        salePlan: {}
      },
      selectMode: 'inner',
      conditions: {
        OBJECT_ID: '', // 销售订单号
        PROCESS_TYPE: 'ZS01', // 销售订单类型
        CUSTOMER: '', // 订单客户编号
        CUST_NAME: '', // 订单客户名称
        CUSTOMER_TYPE: '', // 订单客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建人
        ZZFLD00002D_DSCR: '', // 创建人描述
        POSTING_DATE: '', // 创建日期
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD000001Name: '', // 营销单元描述
        ZZFLD00003E: '', // 基地
        ZZFLD000002: '', // 省
        ZZFLD000002_TEXT: '',
        ZZFLD000003: '', // 市
        ZZFLD000003_TEXT: '',
        ZCUSTOM_NAME: '',
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员描述
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系电话
        ZZFLD00002N: '', // 收货地址
        ZZFLD00009O: '', // 已占用开票数量
        ZHKYE: '', // 货款余额
        followMarginMoney: '', // 随量保证金
        billingRequire: '', // 开票要求
        fixedMarginMoney: '', // 固定保证金
        remark: '',
        ZZFLD00003C: 'WEB'
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40, params: { bgEdit: true }},
          { field: 'NUMBER_INT', title: '行号', slots: { default: 'NUMBER_INT' }, width: 50 },
          {
            field: 'ZZFLD00002P',
            title: '关联行项目号',
            slots: { default: 'ZZFLD00002P' },
            width: 120
          },
          {
            field: 'ZZFLD000006',
            title: '客户订单日期',
            slots: { default: 'ZZFLD000006' },
            width: 120,
            editRender: {},
            params: { bgEdit: true }
          },

          {
            field: 'ZZFLD000005',
            title: '销售计划编号',
            width: 120,
            slots: { default: 'ZZFLD000005' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002Q_TEXT',
            title: '销售计划类型',
            width: 180
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 180,
            slots: { default: 'ORDERED_PROD' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 250
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 180
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'USE_BOT',
            title: '瓶数',
            width: 80,
            slots: { default: 'USE_BOT' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80
          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100
          },
          {
            field: 'ZZFLD00002Z',
            title: '税价合计',
            width: 100
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180
          },
          {
            field: 'ZY_BILL_BOT',
            title: '已占用开票瓶数',
            width: 180
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180
          },
          {
            field: 'LJ_BILL_BOT',
            title: '累计开票瓶数',
            width: 180
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        data: [],
        delData: []
      },
      rewardList: [
        {
          field: 'REWARD_TYPE',
          title: '奖励类型编码',
          width: 100,
          slots: { default: 'REWARD_TYPE' },
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NUMBER',
          title: '奖励/计划编号',
          width: 120,
          slots: { default: 'REWARD_NUMBER' },
          editRender: {},
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NAME',
          title: '项目/计划类型',
          width: 180
        },
      ],
      gridOptionsCash: {
        columns: [
          {
            field: 'REWARD_NUMBER',
            title: '项目奖励编码',
            width: 120
          },
          {
            field: 'REWARD_ID',
            title: '项目类型编码',
            width: 120
          },
          {
            field: 'REWARD_NAME',
            title: '项目类型描述',
            width: 180
          },
          {
            field: 'CUSTOMER',
            title: '项目客户编码',
            width: 120
          },
          {
            field: 'CUSTOMER_NAME',
            title: '项目客户名称',
            width: 180
          },
          {
            field: 'START_DATE',
            title: '有效期起',
          },
          {
            field: 'END_DATE',
            title: '有效期止',
          },
          {
            field: 'QUOTA_RATIO',
            title: '额度比例(%)',
          },
          {
            field: 'AMOUNT',
            title: '项目金额（元）',
          },
          {
            field: 'REMAIN_AMOUNT',
            title: '剩余金额（元）',
          },
        ],
        data: [],
        delData: []
      },
      gridOptionsPromotion: {
        columns: [
          {
            field: 'PLAN_NUMBER',
            title: '销售计划编号',
            width: 120
          },
          {
            field: 'PLAN_TYPE_DSCR',
            title: '计划类型',
          },
          {
            field: 'WLYBRAND_NAME',
            title: '存货分类',
          },
          {
            field: 'GJAHR',
            title: '年度',
          },
          {
            field: 'MONAT',
            title: '月份',
          },
          {
            field: 'TOTAL_QTY',
            title: '总计划量(件)',
          },
          {
            field: 'INITPLAN_QTY',
            title: '初始计划量(件)',
          },
          {
            field: 'BILLING_QTY',
            title: '已开票计划量(件)',
          },
          {
            field: 'ATP_QTY',
            title: '已占用计划量(件)',
          },
          {
            field: 'REMAIN_QTY',
            title: '剩余可用计划量(件)',
          },
          {
            field: 'SPCT_CHG_QTY',
            title: '签约调整量(件)',
          },
        ],
        data: [],
        delData: []
      },
      gridOptionsOuterPlan: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40, params: { bgEdit: true }},
          { field: 'NUMBER_INT', title: '行号', slots: { default: 'NUMBER_INT' }, width: 50 },
          {
            field: 'ZZFLD00002P',
            title: '关联行项目号',
            slots: { default: 'ZZFLD00002P' },
            width: 120
          },
          {
            field: 'ZZFLD000006',
            title: '客户订单日期',
            width: 120,
            formatter: ({ cellValue }) => formatSapDate(cellValue)
          },
          {
            field: 'ZZFLD000005',
            title: '销售计划编号',
            width: 120
          },
          {
            field: 'ZZFLD00002Q_TEXT',
            title: '销售计划类型',
            width: 180
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 140
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 250
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 100
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80
          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100
          },
          {
            field: 'ZZFLD00002Z',
            title: '税价合计',
            width: 100
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: {
              default: 'ZZFLD00002B'
            }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        data: [],
        delData: []
      },
      gridOptionsPlanDetail: {
        columns: [
          {
            field: 'ZZFLD00000C',
            title: '销售计划编号',
            slots: { default: 'ZZFLD00000C' },
            width: 120
          },
          {
            field: 'ZZFLD00000D_TEXT',
            title: '计划类型',
            slots: { default: 'ZZFLD00000D_TEXT' },
            width: 120
          },
          {
            field: 'ZZFLD00000E_TEXT',
            title: '存货分类',
            slots: { default: 'ZZFLD00000E_TEXT' },
            width: 120
          },
          {
            field: 'ZZFLD00000F',
            title: '年度',
            slots: { default: 'ZZFLD00000F' },
            width: 70
          },
          {
            field: 'ZZFLD00000G',
            title: '月份',
            slots: { default: 'ZZFLD00000G' },
            width: 70
          },
          {
            field: 'ZZFLD00000H',
            title: '总计划量(件)',
            slots: { default: 'ZZFLD00000H' },
            width: 120
          },
          {
            field: 'ZZFLD00000J',
            title: '初始计划量(件)',
            width: 120,
            slots: { default: 'ZZFLD00000J' }
          },
          {
            field: 'ZZFLD00000L',
            title: '已占用计划量(件)',
            width: 120,
            slots: { default: 'ZZFLD00000L' }
          },
          {
            field: 'ZZFLD00000N',
            title: '已开票计划量(件)',
            width: 120,
            slots: { default: 'ZZFLD00000N' }
          },
          {
            field: 'SPCT_CHG_QTY',
            title: '调整量(审批中)',
            width: 120,
            slots: { default: 'SPCT_CHG_QTY' }
          },
          {
            field: 'ZZFLD00000P',
            title: '剩余可用计划量(件)',
            width: 120,
            slots: { default: 'ZZFLD00000P' }
          },
          {
            field: 'ZZFLD00000R',
            title: '本次占用计划数量(件)',
            width: 140,
            slots: { default: 'ZZFLD00000R' }
          },

          {
            field: 'TOTAL_BOT',
            title: '总计划量(瓶)',
            slots: { default: 'TOTAL_BOT' },
            width: 120
          },
          {
            field: 'INITPLAN_BOT',
            title: '初始计划量(瓶)',
            width: 120,
            slots: { default: 'INITPLAN_BOT' }
          },
          {
            field: 'ATP_BOT',
            title: '已占用计划量(瓶)',
            width: 120,
            slots: { default: 'ATP_BOT' }
          },
          {
            field: 'BILLING_BOT',
            title: '已开票计划量(瓶)',
            width: 120,
            slots: { default: 'BILLING_BOT' }
          },
          {
            field: 'REMAIN_BOT',
            title: '剩余可用计划量(瓶)',
            width: 120,
            slots: { default: 'REMAIN_BOT' }
          },
          {
            field: 'CURNT_ATPBOT',
            title: '本次占用计划数量(瓶)',
            width: 140,
            slots: { default: 'CURNT_ATPBOT' }
          },
          {
            field: 'IMP_RATE',
            title: '执行率',
            width: 120,
            slots: { default: 'IMP_RATE' }
          },
          {
            field: 'IMP_RATE_ALL',
            title: '执行率(含占用)',
            width: 120,
            slots: { default: 'IMP_RATE_ALL' }
          },
        ],
        data: []
      },
      gridOptionsRelevanceDetail: {
        columns: [
          {
            field: 'ZZFLD00000C',
            title: '销售计划编号',
            slots: { default: 'ZZFLD00000C' },
            width: 100
          },
          {
            field: 'ZZFLD00000D_TEXT',
            title: '计划类型',
            slots: { default: 'ZZFLD00000D_TEXT' },
            width: 160
          },
          {
            field: 'ZZFLD00000E_TEXT',
            title: '存货分类',
            slots: { default: 'ZZFLD00000E_TEXT' },
            width: 80
          },
          {
            field: 'ZZFLD00000F',
            title: '年度',
            slots: { default: 'ZZFLD00000F' },
            width: 45
          },
          {
            field: 'ZZFLD00000G',
            title: '月份',
            slots: { default: 'ZZFLD00000G' },
            width: 45
          },
          {
            field: 'ZZFLD00000H',
            title: '总计划量',
            slots: { default: 'ZZFLD00000H' },
            width: 70
          },
          {
            field: 'ZZFLD00000J',
            title: '初始计划量',
            width: 80,
            slots: { default: 'ZZFLD00000J' }
          },
          {
            field: 'ZZFLD00000L',
            title: '已占用计划量',
            width: 100,
            slots: { default: 'ZZFLD00000L' }
          },
          {
            field: 'ZZFLD00000N',
            title: '已开票计划量',
            width: 100,
            slots: { default: 'ZZFLD00000N' }
          },
          {
            field: 'SPCT_CHG_QTY',
            title: '调整量(审批中)',
            width: 90,
            slots: { default: 'SPCT_CHG_QTY' }
          },
          {
            field: 'ZZFLD00000P',
            title: '剩余可用计划量',
            width: 110,
            slots: { default: 'ZZFLD00000P' }
          },
          {
            field: 'ZZFLD00000R',
            title: '本次占用计划数量',
            width: 120,
            slots: { default: 'ZZFLD00000R' }
          },
          {
            field: 'IMP_RATE',
            title: '执行率',
            width: 60,
            slots: { default: 'IMP_RATE' }
          },
          {
            field: 'IMP_RATE_ALL',
            title: '执行率(含占用)',
            width: 100,
            slots: { default: 'IMP_RATE_ALL' }
          },
        ],
        data: []
      },
      gridOptionsLinkBill: {
        columns: [
          {
            field: 'ZZFLD000011',
            title: '单据编号'
          },
          {
            field: 'ZZFLD000012_TEXT',
            title: '单据类型'
          },
          {
            field: 'ZZFLD000013',
            title: '创建日期',
            formatter: ({ cellValue }) => formatSapDate(cellValue)
          }
        ],
        data: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          {
            field: 'FILELENGTH',
            title: '大小',
            formatter: ({ cellValue }) => formatSapFileSize(cellValue)
          },
          {
            field: 'CREATED_DATE',
            title: '上传日期',
            formatter: ({ cellValue }) => formatSapDate(cellValue)
          },
          {
            field: 'CREATED_TIME',
            title: '上传时间',
            formatter: ({ cellValue }) => formatSapTime(cellValue)
          }
        ],
        data: [],
        delData: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD000031', title: '操作人姓名' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'ZZFLD00000X', title: '变更时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      gridOptionsNext: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 50 },
          { field: 'order_type', title: '单据类型' },
          { field: 'text', title: '单据描述' }
        ],
        data: [
          { order_type: 'ZM02', text: '配额酒材料计划' },
          { order_type: 'ZPD2', text: '配额酒生产计划' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.OBJECT_ID) {
        return !this.showEdit
      } else {
        return false
      }
    },
    ...mapGetters(['customerInfo', 'role'])
  },
  watch: {
    'conditions.CUSTOMER': {
      handler(nv) {
        this.productParams.CUSTOMER = nv
      }
    },
    'gridOptions.data': {
      handler(nv, ol) {
        console.log(`output->nv`,nv)
        nv.forEach((item, i) => {
          item.NUMBER_INT = (i + 1) * 10
        })
      },
      deep: true
    },
    'conditions.CUST_NAME': {
      handler(nv) {
        this.productParams.zzfld000001 = this.conditions.ZZFLD000001
      }
    }
  },
  created() {
    const pageQuery = this.$route.query
    if (pageQuery?.object_id) {
      // this.mode = 'edit'
      this.pageMode = 'edit'
      this.initOrderInfoById(pageQuery.object_id, 1)
    } else {
      if (this.role.ROLE === 'WLY001') {
        const orgList = this.customerInfo.yxdy.filter(v => v.mc_short !== '其他销售类型')
        this.conditions.CUSTOMER = this.customerInfo.info.partner
        this.conditions.CUSTOMER_TYPE = this.customerInfo.info.zzfld000016
        this.conditions.CUST_NAME = this.customerInfo.info.name_org1
        this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
        this.conditions.ZZFLD000001Name = orgList[0].mc_short
        this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
        this.conditions.ZZFLD000002 = this.customerInfo.info.region
        this.conditions.ZZFLD000002_TEXT = this.customerInfo.info.bezei
        this.conditions.ZZFLD000003 = this.customerInfo.info.city_code
        this.conditions.ZZFLD000003_TEXT = this.customerInfo.info.city_name
        this.conditions.ZZFLD000004 = this.customerInfo.info.sales_emp
        this.conditions.ZZFLD000004_DSCR = this.customerInfo.info.sales_emp_name
        this.productParams.CUSTOMER = this.customerInfo.info.partner
        this.$set(this.selectDataOptions, 'orgList', orgList)
      }
      this.conditions.ZZFLD00002D = this.role.USER_BP
      this.conditions.ZZFLD00002D_DSCR = this.role.login_user
      this.conditions.POSTING_DATE = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.tableEvent('innerAdd')
    }
    if(this.role.ROLE == 'WLY002' || this.role.ROLE == 'WLYALL'){
      this.gridOptions.columns.splice(3, 0, ...this.rewardList);
    }
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    // 是否选项
    this.getSelectDictDataOrigin('B0099')
    this.getSelectDictDataOrigin('A0009')
    // 奖励政策
    this.getSelectDictDataOrigin('A0076')
  },
  methods: {
    changeType(e,idx){
      if(e == 'V001'){
        this.gridOptions.data[idx].ZZFLD00002A = 'V003'
      }else if(e == 'V002'){
        this.gridOptions.data[idx].ZZFLD00002A = 'V002'
      }else{
        this.gridOptions.data[idx].REWARD_NUMBER = ''
        this.gridOptions.data[idx].REWARD_ID = ''
        this.gridOptions.data[idx].REWARD_NAME = ''
        this.gridOptions.data[idx].ZZFLD00002A = ''
      }
    },
    cellClassName({ column }) {
      if (column.params?.bgEdit) {
        return 'cell--bg--edit'
      } else {
        return 'cell--bg--default'
      }
    },
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID, type = 0) {
      this.loading = true
      try {
        const res = await getOrderDetail({ OBJECT_ID })
        if (res?.MSGTYPE === 'S') {
          const { DATA } = res
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.follow_up = res.FOLLOW_UP
          this.conditions.change = res.CHANGE
          this.conditions.cancel = res.CANCEL
          this.gridOptions.data = DATA.ITEM_INNER || []
          this.gridOptionsOuterPlan.data = DATA.ITEM_OUTER || []
          this.gridOptionsHistory.data = DATA.HISTORY || []
          this.gridOptionsPlanDetail.data = DATA.USE || []
          this.gridOptionsRelevanceDetail.data =  DATA.IMP_RATE || []
          this.gridOptionsFile.data = DATA.ATTACHMENT || []
          this.gridOptionsLinkBill.data = DATA.CONNECT || []
          this.gridOptionsCash.data = DATA.CASH || []
          type && this.initCustome()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    async createNext() {
      const data = this.$refs.next.getRadioRecord()
      if (data) {
        const params = {
          user_bp: this.role.USER_BP,
          head: this.conditions,
          plan_type: data.order_type,
          item_inner: this.gridOptions.data,
          item_outer: this.gridOptionsOuterPlan.data,
          mode: 'QUOTA'
        }
        const res = await apiCreateFollow(params)
        this.$router.push({
          name: data.order_type === 'ZM02' ? '40.01 材料计划单创建' : '50.01 生产计划单创建',
          params: res
        })
      } else {
        this.$message.warning('请选择有效数据！')
      }
    },
    async orderModify() {
      const res = await this.orderlock('ADD')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = true
    },
    async orderDisplay() {
      const res = await this.orderlock('DELETE')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = false
    },
    // 订单解锁
    async orderlock(mode) {
      this.errorList = []
      const params = {
        type: this.conditions.PROCESS_TYPE,
        number: this.conditions.OBJECT_ID,
        status: mode === 'ADD' ? 1 : 2
      }
      if (mode === 'UNLOCK') {
        await this.$confirm('解锁前请确认当前没有其他人修改此订单！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
      const { data } = await apiOrderLock(params)
      if (data.status && params.status === 1) {
        this.errorList = [data.message]
        return false
      }
      return true
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 保存 提交 确认  新建 E0001,已保存待提交 E0002,已提交待审核 E0003, 审核通过 E0004,审核拒绝 E0005,已取消 E0006
    changeStatus(status) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          // await this.confirmMode(status)
          const params = {
            user_bp: this.role.USER_BP,
            mode: status,
            info: this.conditions,
            item_inner: this.gridOptions.data.concat(this.gridOptions.delData),
            item_outer: this.gridOptionsOuterPlan.data.concat(this.gridOptionsOuterPlan.delData),
            use: this.gridOptionsPlanDetail.data,
            item_d: [],
            attachment: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
          }
          this.loading = true
          this.errorList = []
          const result = await apiQuotaSave(params)
          if (result?.MSGTYPE === 'S') {
            this.$message.success(result.MESSAGE)
            this.gridOptions.delData = []
            this.gridOptionsOuterPlan.delData = []
            this.gridOptionsFile.delData = []
            this.conditions.OBJECT_ID = result.DATA.INFO.OBJECT_ID
            this.orderDisplay()
          } else {
            this.errorList.push(result.MESSAGE)
            this.loading = false
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        partner: this.conditions.CUSTOMER,
        user_bp: this.role.USER_BP
      }
      const { data } = await apiSapSingleClientInfo(params)
      const orgList = data.yxdy.filter(v => v.mc_short !== '其他销售类型')
      this.$set(this.selectDataOptions, 'orgList', orgList)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD000001Name = checkedData.mc_short
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
      this.productParams.zzfld000001 = e
      this.errorList = []
      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsOuterPlan.data = []
      this.gridOptionsOuterPlan.delData = []
      this.gridOptionsPlanDetail.data = []
      this.gridOptionsPlanDetail.delData = []
      this.gridOptionsRelevanceDetail.data = []
      this.gridOptionsLinkBill.data = []
      this.tableEvent('innerAdd')
    },
    tableEvent(btn) {
      if (this.$_has('WLY001')) {
        if (this.gridOptions.data.length === 1) {
          this.$message.error('最多添加一行！')
          return
        }
      }
      const orderDetailsEmpty = {}
      this.gridOptions.columns.forEach(v => {
        !v.type && (orderDetailsEmpty[v.field] = '')
      })
      orderDetailsEmpty.ZZFLD000006 = this.parseTime(new Date())
      switch (btn) {
        case 'innerAdd':

          orderDetailsEmpty.ZZFLD000029 = 'V001'
          // orderDetailsEmpty.NUMBER_INT = (this.gridOptions.data.length + 1) * 10
          this.gridOptions.data.push(orderDetailsEmpty)
          break
      }
    },
    deleteSaleItem(type) {
      let checkedList = null
      // 如果是计划内，检查是否有关联行号 ZZFLD00002P，删除关联的行号 NUMBER_INT
      if (type === 'ITEM_INNER') {
        checkedList = this.$refs.xTable0.getCheckboxRecords()
        if (!checkedList.length) return this.$message.warning('请选择有效数据！')
        checkedList.forEach(item => {
          // 需要删除的直接添加删除标记
          item.MODE = 'D'
          if (item.ZZFLD00002P) {
            const index = this.gridOptionsOuterPlan.data.findIndex(
              v => v.NUMBER_INT === item.ZZFLD00002P
            )
            if (index > -1) {
              if (this.conditions.OBJECT_ID) {
                // 添加删除标记
                this.gridOptionsOuterPlan.data[index].MODE = 'D'
                // 保存删除的计划外行（计划外）
                this.gridOptionsOuterPlan.delData.push(this.gridOptionsOuterPlan.data[index])
              }
              // 删除关联行
              this.gridOptionsOuterPlan.data.splice(index, 1)
            }
          }
          const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
          this.gridOptions.data.splice(index, 1)
        })
        if (this.conditions.OBJECT_ID) {
          // 保存一下删除的数据（计划内）
          this.gridOptions.delData = this.gridOptions.delData.concat(checkedList.filter(v => v.GUID))
        }
      } else {
        checkedList = this.$refs.xTable1.getCheckboxRecords()
        if (!checkedList.length) return this.$message.warning('请选择有效数据！')
        checkedList.forEach(item => {
          item.MODE = 'D'
          const index = this.gridOptionsOuterPlan.data.findIndex(v => v._X_ID === item._X_ID)
          this.gridOptionsOuterPlan.data.splice(index, 1)
        })
        if (this.conditions.OBJECT_ID) {
          // 保存删除的行（计划外）
          this.gridOptionsOuterPlan.delData = this.gridOptionsOuterPlan.data.concat(
            checkedList.filter(v => v.GUID)
          )
        }
      }
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}{m}{d}')
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效的数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(
          checkedList.filter(v => v.GUID)
        )
      }
    },
    async uploadFile(file) {
      // console.log(file);
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        const dateTime = new Date().getTime()

        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type,
          DOC_TYPE: file.raw.type,
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.USER_BP,
          ZZFLD00002D_DSCR: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    },
    // 打开窗口
    openSelectDialog(e, type, row = {}, mode) {
      e.target.blur()
      this.innerCurrentDetail = row
      this.showDialogType = type
      this.item_type = mode
      this.dialogTitle = {
        product: '产品选择',
        client: '客户选择',
        salePlan: '销售计划选择',
        reward: '剩余现金奖励选择',
      }[type]
      if( type === 'reward' && row.REWARD_TYPE === 'V002'){
        this.dialogTitle = '剩余促销奖励选择'
      }
      this.showDialog = true
    },
    // 保存
    saveSaleItem(type) {
      this.updateSaleItem(type)
    },
    // 选择订单客户
    selectClient(res) {
      const orgList = res.orgList.filter(v => v.mc_short !== '其他销售类型')
      this.conditions.CUSTOMER = res.partner
      this.conditions.CUSTOMER_TYPE = res.zzfld000016
      this.conditions.CUST_NAME = res.name_org1
      this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
      this.conditions.ZZFLD000001Name = orgList[0].mc_short
      this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
      this.conditions.ZZFLD000002 = res.region
      this.conditions.ZZFLD000002_TEXT = res.bezei
      this.conditions.ZZFLD000003 = res.city_code
      this.conditions.ZZFLD000003_TEXT = res.city_name
      this.conditions.ZZFLD000004 = res.sales_emp
      this.conditions.ZZFLD000004_DSCR = res.sales_emp_name
      this.productParams.CUSTOMER = res.partner
      this.$set(this.selectDataOptions, 'orgList', orgList)
      this.gridOptions.data = []
      this.gridOptions.delData = []
      this.gridOptionsOuterPlan.data = []
      this.gridOptionsOuterPlan.delData = []
      this.gridOptionsPlanDetail.data = []
      this.gridOptionsPlanDetail.delData = []
      this.gridOptionsRelevanceDetail.data = []
      this.gridOptionsLinkBill.data = []
      this.tableEvent('innerAdd')
    },
    // 选择产品
    async selectProduct(res) {
      this.innerCurrentDetail.ORDERED_PROD = res.PRODUCT_ID
      this.innerCurrentDetail.UNIT = res.MSEHT
      this.innerCurrentDetail.DESCRIPTION = res.SHORT_TEXT
      this.innerCurrentDetail.ZZFLD00002S = res.NORMS

      const params = {
        info: this.conditions,
        item: this.innerCurrentDetail,
        page: 1,
        pagesize: 50
      }
      console.log(params)
      const { DATA } = await getSalePlanNumber(params)
      if (DATA.length === 1) {
        this.innerCurrentDetail.ZZFLD000005 = DATA[0].PLAN_NUMBER
      }

      this.updateSaleItem()
    },
    // 更新项目行
    async updateSaleItem(type) {
      // 创建数据副本，避免修改原始数据
      let itemInnerData = []
      if (this.gridOptions.data && this.gridOptions.data.length > 0) {
        itemInnerData = this.gridOptions.data.map((item, index) => {
          const newItem = { ...item }
          // 提交前判断明细中REWARD_TYPE是否等于V001，如果是则置空指定属性值
          // 只处理第2条及以上的数据（index >= 1）
          if (newItem.REWARD_TYPE === 'V001' && index >= 1) {
            newItem.ZZFLD000005 = ''
            newItem.ZZFLD00002Q = ''
            newItem.ZZFLD00002Q_TEXT = ''
          }
          return newItem
        })
      }
      
      const params = {
        item_type: type || this.item_type,
        info: this.conditions,
        item_inner: itemInnerData,
        item_outer: this.gridOptionsOuterPlan.data
      }
      this.errorList = []
      const result = await apiQuotaUpdateSaleItem(params)
      // if (result?.MSGTYPE === 'S') {
      if (result?.MSGTYPE === 'E') {
        this.errorList.push(result.MESSAGE)
      }
      const { DATA } = result
      this.gridOptionsCash.data = DATA.CASH_REWARD
      this.gridOptionsPromotion.data = DATA.PROMOTION
      this.gridOptions.data = DATA.ITEM_INNER
      this.gridOptionsOuterPlan.data = DATA.ITEM_OUTER
      this.gridOptionsPlanDetail.data = DATA.USE
      this.gridOptionsRelevanceDetail.data = DATA.IMP_RATE || []
      // }
      console.log(result)
    },
    // 选择销售计划编号
    selectSalePlan(res) {
      this.innerCurrentDetail.ZZFLD000005 = res.PLAN_NUMBER
      // this.innerCurrentDetail.ZZFLD00002Q = res.PLAN_TYPE
      this.updateSaleItem()
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        switch (this.showDialogType) {
          case 'product':
            this.selectProduct(res)
            break
          case 'client':
            this.selectClient(res)
            break
          case 'salePlan':
            this.selectSalePlan(res)
          case 'reward':
            this.selectReward(res)
        }
        this.showDialog = false
      })
    },
    selectReward(res){
      this.innerCurrentDetail.REWARD_NUMBER = res.reward_number || res.plan_number
      this.innerCurrentDetail.REWARD_ID = res.reward_id || res.plan_type
      this.innerCurrentDetail.REWARD_NAME = res.reward_name || res.plan_type_dscr
      this.updateSaleItem()
    },
    // 控件回车
    async handleEnter(e, type, data, row, mode) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      this.innerCurrentDetail = row
      this.item_type = mode

      switch (type) {
        case 'customer':
          this.selectClient(data)
          break
        case 'salesProduct':
          this.selectProduct(data)
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/quotaEdit.vue